import { cn as i } from "../../../lib/utils.es.js";
import { BaseInput as a } from "./BaseInput.es.js";
import { BaseLabel as b } from "./BaseLabel.es.js";
import { jsx as e, jsxs as p } from "react/jsx-runtime";
var s = ({ className: l, ...t }) => /* @__PURE__ */ e(a, {
  className: i("lib:peer", l),
  ...t
}), n = ({ className: l, ...t }) => /* @__PURE__ */ e(b, {
  className: i("lib:pointer-events-none lib:absolute lib:start-0 lib:z-10 lib:origin-[0] lib:scale-75 lib:transform lib:cursor-text lib:text-gray-500 lib:duration-300 lib:peer-placeholder-shown:scale-100 lib:peer-placeholder-shown:text-dark-60 lib:peer-focus:scale-75 lib:peer-focus:px-0 lib:peer-focus:text-dark-100 lib:rtl:peer-focus:left-auto lib:rtl:peer-focus:translate-x-1/4", "lib:bottom-4.5 lib:-translate-y-5 lib:peer-placeholder-shown:-bottom-3 lib:peer-focus:bottom-4.5 lib:peer-focus:-translate-y-5 lib:md:bottom-7 lib:peer-focus:md:bottom-7", l),
  ...t
}), h = "lib:[&_input]:h-13.5 lib:[&_input]:pt-4.5 lib:[&_input]:md:h-16 lib:[&_input]:md:pt-7", f = ({ id: l, label: t, placeholder: r, ...o }) => /* @__PURE__ */ p("div", {
  className: i("lib:relative", t && "lib:[&_input]:h-13.5 lib:[&_input]:pt-4.5 lib:[&_input]:md:h-16 lib:[&_input]:md:pt-7"),
  children: [/* @__PURE__ */ e(s, {
    id: l,
    placeholder: t ? "" : r,
    ...o
  }), t && /* @__PURE__ */ e(n, {
    htmlFor: l,
    children: t
  })]
});
export {
  n as FloatingLabel,
  f as Input,
  n as UiFloatingLabel,
  f as UiInput,
  h as withLabelClass
};
